import React from 'react';
import instance from '../../utils/Api';
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Typography, Button } from "@mui/material";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import { useGlobalContext } from '../../Contex'; // Adjust the path

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const Status_product = ({ open, handleClose, product, setAddproducts }) => {
    const { buttondisable, setButtondisable } = useGlobalContext();
    // API call to toggle product status
    const handleToggleStatus = async () => {
        setButtondisable(true);
        try {
            const response = await instance.patch(`/Products/ToggleProductStatus?product_id=${product._id}`);
            if (response.data.success === true) {
                toast.success(response.data.message);
                handleClose();
                setAddproducts(true); // Trigger refresh after updating the status   
                setButtondisable(false);
            } else {
                toast.error(response.data.message);
                setButtondisable(false);
            }
        } catch (error) {
            toast.error(error?.response?.data?.error);
            console.log(error.response);
            setButtondisable(false);
        }
    };
    return (
        <React.Fragment>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                className="admin-admins"
            >
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                    Change Item Status
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <Typography>
                        Are you sure you want to change the status for <strong>{product?.product_name}</strong> ?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button className="cancel-btn" onClick={handleClose}>Cancel</Button>
                    <Button className="add-btn" disabled={buttondisable} onClick={handleToggleStatus}>Yes</Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    )
}

export default Status_product